import i18n from "i18next"
import i18nBackend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

export const languagePresets = {
  en: ["en", "en-US"],
  ru: ["ru", "by", "kz", "kg", "tj", "uz", "am", "az", "md"],
  uk: ["uk", "uk-UA"]
}

const getFallbackLanguages = (lng: string) => {
  let lang = "en"

  Object.entries(languagePresets).forEach(([key, values]) => {
    if (values.includes(lng)) {
      lang = key
    }
  })

  return lang
}

i18n.on("languageChanged", (lng) => {
  const lang = getFallbackLanguages(lng)

  i18n.language = lang

  document.documentElement.lang = lang
})

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/localization/{{lng}}/{{ns}}.json?v=${import.meta.env.VITE_APP_VERSION}`
    },
    defaultNS: "common",
    ns: ["common"],
    fallbackLng: (lng) => getFallbackLanguages(lng),
    supportedLngs: ["en", "ru", "uk"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"]
    },
    react: {
      useSuspense: false
    },
    debug: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
